module.exports = __webpack_public_path__ + "assets/img/kv-86de0286.jpg";